import { useLocation } from 'react-router-dom'

import { Navigate } from '@lib/react-router-dom'

import { IB_DEFAULT_REGISTER_PAGE_PATH } from '@pages/IntroducingBroker/IntroducingBrokerRoutes'
import { IBSignupThankYouPage } from '@pages/IntroducingBroker/SignUp/ThankYou/IBSignupThankYouPage'

import { useAccountReadContext } from '@context/AccountContextContext'

import { CommonPaths } from '@utils/path'

export const IBSignupThankYouPageGuard = () => {
  const { account } = useAccountReadContext()
  const location = useLocation()

  if (!location.state?.fromQuestionnaire) {
    const path = account?.clientIntroducingBroker?.id
      ? CommonPaths.IntroducingBrokerDashboard
      : IB_DEFAULT_REGISTER_PAGE_PATH

    return <Navigate to={path} replace />
  }

  return <IBSignupThankYouPage />
}
